import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import ProfileSection from '../components/profile/ProfileSection';
import { normalizeCity } from '@/lib/city/normalizer';

const Profile: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  // 1. Read & normalize city param
  const cityParam = searchParams.get('city');
  const normalizedCity = cityParam ? normalizeCity(cityParam) : null;

  // 2. Redirect once on mount if spelling differs
  useEffect(() => {
    if (cityParam && normalizedCity && normalizedCity !== cityParam) {
      const newParams = new URLSearchParams(location.search);
      newParams.set('city', normalizedCity);
      navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    }
  }, [location.key]); // only on first render

  // Tab‐state logic (unchanged)
  const urlTab = searchParams.get('tab');
  const locationState = location.state as { activeTab?: string };
  const initialTab = (urlTab || locationState?.activeTab || 'posts') as string;
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    const newTabParam = new URLSearchParams(location.search).get('tab');
    if (newTabParam && newTabParam !== activeTab) {
      setActiveTab(newTabParam);
    }
  }, [location.search]);

  const handleTabChange = (tab: string) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set('tab', tab);
    navigate(`?${newParams.toString()}`, { replace: true });
    setActiveTab(tab);
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <ProfileSection defaultTab={activeTab} onTabChange={handleTabChange} />
      </div>
    </DashboardLayout>
  );
};

export default Profile;
